<style>
.ag-theme-material .ag-cell {
    line-height: 35px !important;
}
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap items-center justify-between">
                <div class="mb-4 mr-4 md:mb-0 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Client</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        @click="form = { name: '', client_code: '', address_1: '', address_2: '', area_id: null, clienttype_id: null }; showAddForm = true"
                        class="mb-4 mr-1 btn md:mb-0"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        :to="{ name: 'master-client-view', params: {id: selectedId} }"
                        class="mb-4 mr-1 md:mb-0"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="removeItem"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 mr-1 md:mb-0"
                        @click="filterActive"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="my-4 ag-theme-material w-100 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="clients"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>
            <vs-prompt title="Filter" :active.sync="showFilter" buttons-hidden>
                <div class="con-exemple-prompt">
                    <vs-input
                        label="Client Code"
                        v-model="filter.client_code"
                        class="w-full mb-2"
                    />
                    <vs-input
                        label="Client Name"
                        v-model="filter.name"
                        class="w-full mb-2"
                    />
                    <vs-input
                        label="Address 1"
                        v-model="filter.address_1"
                        class="w-full mb-2"
                    />
                    <vs-input
                        label="Address 2"
                        v-model="filter.address_2"
                        class="w-full mb-2"
                    />
                    <label class="vs-input--label">Area</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="filter.area_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, area)"
                    >
                        <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                    </vs-select>
                    <label class="vs-input--label">Client Type</label>
                    <vs-select
                        class="selectExample"
                        v-model="filter.clienttype_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, client_type)"
                    >
                        <vs-select-item v-for="(item, index) in client_type.data" :key="index" :value="item.id" :text="item.client_type"/>
                    </vs-select>

                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                        <vs-button type="flat" class="mr-2" @click="resetFilter">Reset</vs-button>
                        <vs-button color="primary" @click="filterData">Search</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
                <div class="con-exemple-prompt">
                    <vs-input
                        v-model="form.client_code"
                        class="w-full mb-2 wr_input"
                        label="Client Code *"
                    />
                    <vs-input
                        v-model="form.name"
                        class="w-full mb-2 wr_input"
                        label="Client Name *"
                    />
                    <vs-input
                        v-model="form.address_1"
                        class="w-full mb-2 wr_input"
                        label="Address 1 *"
                    />
                    <vs-input
                        v-model="form.address_2"
                        class="w-full mb-2 wr_input"
                        label="Address 2 *"
                    />
                    <label class="vs-input--label">Area</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.area_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, area)"
                    >
                        <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                    </vs-select>
                    <label class="vs-input--label">Client Type</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.clienttype_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, client_type)"
                    >
                        <vs-select-item v-for="(item, index) in client_type.data" :key="index" :value="item.id" :text="item.client_type"/>
                    </vs-select>
                    <vs-input
                        v-model="form.ship_as_name"
                        class="w-full mb-2 wr_input"
                        label="Ship As"
                    />
                    <vs-input
                        v-model="form.ship_as_address"
                        class="w-full mb-2 wr_input"
                        label="Address"
                    />

                    <label class="vs-input--label">Inventory Type</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.inv_type_id"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, inv_type)"
                    >
                        <vs-select-item v-for="(item, index) in inv_type.data" :key="index" :value="item.id" :text="item.name"/>
                    </vs-select>

                    <label class="vs-input--label">Business Type</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.business_type"
                        width="100%"
                        autocomplete
                        @input-change="searchDropdown($event, businessType)"
                    >
                        <vs-select-item v-for="(item, index) in businessType.data" :key="index" :value="item.id" :text="item.code"/>
                    </vs-select>

                    <label class="vs-input--label">Storage Type</label>
                    <div class="vx-col w-full">
                        <vs-checkbox v-model="form.st_fulfillment">Fulfillment</vs-checkbox>
                        <vs-checkbox v-model="form.st_conventional">Conventional & Document (PCS - Storage)</vs-checkbox>
                        <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
                    </div>

                    <label class="vs-input--label">Billing Handling</label>
                    <div class="vx-col w-full">
                        <vs-checkbox v-model="form.bl_inbound">Inbound</vs-checkbox>
                        <vs-checkbox v-model="form.bl_outbound">Outbound</vs-checkbox>
                        <vs-checkbox v-model="form.bl_storage">Storage</vs-checkbox>
                        <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
                    </div>

                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                        <vs-button color="primary" @click="submitData">Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <vs-prompt buttons-hidden title="Edit" :active.sync="showViewForm">
                <div class="con-exemple-prompt">
                    <vs-input
                        v-model="form.client_code"
                        class="w-full mb-2 wr_input"
                        :disabled="!editMode"
                        label="Client Code *"
                    />
                    <vs-input
                        v-model="form.name"
                        class="w-full mb-2 wr_input"
                        label="Client Name *"
                        :disabled="!editMode"
                    />
                    <vs-input
                        v-model="form.address_1"
                        class="w-full mb-2 wr_input"
                        :disabled="!editMode"
                        label="Address 1 *"
                    />
                    <vs-input
                        v-model="form.address_2"
                        class="w-full mb-2 wr_input"
                        :disabled="!editMode"
                        label="Address 2 *"
                    />
                    <label class="vs-input--label">Area</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.area_id"
                        width="100%"
                        :disabled="!editMode"
                        autocomplete
                        @input-change="searchDropdown($event, area)"
                    >
                        <vs-select-item v-for="(item, index) in area.data" :key="index" :value="item.id" :text="item.village"/>
                    </vs-select>
                    <label class="vs-input--label">Client Type</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.clienttype_id"
                        width="100%"
                        :disabled="!editMode"
                        autocomplete
                        @input-change="searchDropdown($event, client_type)"
                    >
                        <vs-select-item v-for="(item, index) in client_type.data" :key="index" :value="item.id" :text="item.client_type"/>
                    </vs-select>
                    <vs-input
                        v-model="form.ship_as_name"
                        class="w-full mb-2 wr_input"
                        label="Ship As"
                        :disabled="!editMode"
                    />
                    <vs-input
                        v-model="form.ship_as_address"
                        class="w-full mb-2 wr_input"
                        label="Address"
                        :disabled="!editMode"
                    />
                    <label class="vs-input--label">Inventory Type</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.inv_type_id"
                        width="100%"
                        :disabled="!editMode"
                        autocomplete
                        @input-change="searchDropdown($event, inv_type)"
                    >
                        <vs-select-item v-for="(item, index) in inv_type.data" :key="index" :value="item.id" :text="item.name"/>
                    </vs-select>

                    <label class="vs-input--label">Business Type</label>
                    <vs-select
                        class="mb-2 selectExample"
                        v-model="form.business_type"
                        width="100%"
                        :disabled="!editMode"
                        autocomplete
                        @input-change="searchDropdown($event, businessType)"
                    >
                        <vs-select-item v-for="(item, index) in businessType.data" :key="index" :value="item.id" :text="item.code"/>
                    </vs-select>

                    <label class="vs-input--label">Storage Type</label>
                    <div class="vx-col w-full">
                        <vs-checkbox v-model="form.st_fulfillment">Fulfillment</vs-checkbox>
                        <vs-checkbox v-model="form.st_conventional">Conventional & Document (PCS - Storage)</vs-checkbox>
                        <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
                    </div>

                    <label class="vs-input--label">Billing Handling</label>
                    <div class="vx-col w-full">
                        <vs-checkbox v-model="form.bl_inbound">Inbound</vs-checkbox>
                        <vs-checkbox v-model="form.bl_outbound">Outbound</vs-checkbox>
                        <vs-checkbox v-model="form.bl_storage">Storage</vs-checkbox>
                        <!-- <vs-radio v-model.number="data.put_block" vs-name="put_block" vs-value="2">Put Block</vs-radio> -->
                    </div>
                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12" class="mt-5">
                        <vs-button color="primary" class="mr-2" @click="editMode = true">Edit</vs-button>
                        <vs-button color="primary" @click="saveData" :disabled="!editMode">Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import { saveAs } from "file-saver";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            searchQuery: "",
            gridOptions: {},
            maxPageNumbers: 7,
            gridApi: null,
            clients: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            showFilter: false,
            filter: {
                name: '',
                client_code: '',
                address_1: '',
                address_2: '',
                area_id: null,
                clienttype_id: null
            },
            clientTypes: [],
            areas: [],
            businessTypes: [],

            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0,
            area: {
                data: [],
                loading: false,
                endpoint: 'master/areas',
                objectKey: 'village'
            },
            client_type: {
                data: [],
                loading: false,
                endpoint: 'master/clienttypes',
                objectKey: 'client_type'
            },
            inv_type: {
                data: [],
                loading: false,
                endpoint: 'master/movementstrategy',
                objectKey: 'name'
            },

            businessType: {
                data: [],
                loading: false,
                endpoint: 'master/businesstypes',
                objectKey: 'name'
            },
            form: {
                name: '',
                client_code: '',
                address_1: '',
                address_2: '',
                area_id: null,
                clienttype_id: null,
                inv_type_id: null,
                business_type: null,
                billing_handling_id: null,
                st_fulfillment: '',
                st_conventional: '',
                bl_inbound: '',
                bl_outbound: '',
                bl_storage: '',
                ship_as_name: '',
                ship_as_addess: ''
            },
            showAddForm: false,
            showViewForm: false,
            editMode: false
        };
    },
    watch: {
        "$store.state.windowWidth"(val) {
            if (val <= 576) {
                this.maxPageNumbers = 4;
                this.gridOptions.columnApi.setColumnPinned("email", null);
            } else this.gridOptions.columnApi.setColumnPinned("email", "left");
        },
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        resetFilter() {
            this.filter = {
                name: '',
                client_code: '',
                address_1: '',
                address_2: '',
                area_id: null,
                clienttype_id: null
            }
        },
        updateSearchQuery(val) {
            this.gridApi.setQuickFilter(val);
        },
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        removeItem() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this client?",
                accept: this.acceptAlert
            });
        },
        submitData() {
            this.isLoading = true;
            this.$http
                .post("master/clients/store", this.form)
                .then(() => {
                    this.isLoading = false;
                    this.showAddForm = false;
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "Successfully added"
                    });
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
        },
        acceptAlert() {
            this.isLoading = true;
            this.$http
                .delete("master/clients/" + this.selectedId + "/destroy")
                .then(res => {
                    this.$vs.notify({
                        color: "success",
                        title: "Client deleted",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected client was successfully deleted"
                    });
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
        },
        refreshData() {
            this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post("master/clients?page=" + this.currentPage, this.filter)
                .then(resp => {
                    this.clients = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                    this.isLoading = false;
                })
                .catch(() => {
                    this.isLoading = false;
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Server Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                });
        },
        viewData() {
            this.isLoading = true;
            this.$http
                .get("master/clients/" + this.selectedId)
                .then(res => {
                    this.editMode = false
                    if (this.area.data.findIndex(a => a.id == res.data.area_id) === -1) {
                        this.area.data.push(res.data.areas)
                    }

                    if (this.client_type.data.findIndex(a => a.id == res.data.clienttype_id) === -1) {
                        this.client_type.data.push(res.data.client_types)
                    }

                    // if (this.inv_type.data.findIndex(a => a.id == res.data.inventory_type) === -1) {
                    //     this.inv_type.data.push(res.data.inventory_types)
                    // }

                    if (this.businessType.data.findIndex(a => a.id == res.data.business_type) === -1) {
                        this.businessType.data.push(res.data.business_types)
                    }


                    this.form = res.data;
                    this.form.client_type_id
                    this.showViewForm = true;
                    this.isLoading = false
                })
                .catch(error => this.handleError(error))
        },
        saveData() {
            this.isLoading = true;
            this.$http
                .put("master/clients/" + this.selectedId + "/update", this.form)
                .then(() => {
                    this.isLoading = false;
                    this.form = {
                        name: '',
                        client_code: '',
                        address_1: '',
                        address_2: '',
                        st_fulfillment: '',
                        st_conventional: '',
                        area_id: null,
                        clienttype_id: null,
                        inv_type_id: null,
                        business_type: null,
                        bl_inbound: '',
                        bl_outbound: '',
                        bl_storage: ''
                    };
                    this.editMode = false;
                    this.showViewForm = false;
                    this.selectedId = null;
                    this.$vs.notify({
                        color: "success",
                        title: "Data Updated",
                        iconPack: "feather",
                        icon: "icon-check",
                        text: "The selected data was successfully updated"
                    });
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
        },
        filterData() {
            this.currentPage = 1;
            this.showFilter = false;
            this.fetchData();
        },
        filterActive() {
            this.showFilter = !this.showFilter;
            Promise.all([
                this.$http.post("master/areas"),
                this.$http.post("master/clienttypes")
            ])
                .then(
                    this.$http.spread((areas, clienttypes) => {
                        this.areas = areas.data.data;
                        this.clientTypes = clienttypes.data.data;
                        setTimeout(() => {
                            this.isLoading = false;
                        }, 500);
                    })
                )
                .catch(() => {
                    this.maxRetry = this.maxRetry - 1;
                    if (this.maxRetry < 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.refreshData();
                            },
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchData();
                });
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/clients/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "Clients-template.xlsx");
                });
        },
        uploadExcel(e) {
            let file = e.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/clients/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    setTimeout(() => {
                        this.$vs.notify({
                            color: "success",
                            title: "Upload Success",
                            text: "Upload Data Inbound Successfully"
                        });
                    }, 500);
                })
                .catch(error => this.handleError(error))
        },
        exportExcel() {
            this.isLoading = true;
            this.$http
                .post("master/clients/report/exportexcel", this.filter, {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "Clients-list-export.xlsx");
                });
        },
        fetchDropdown() {
            this.isLoading = true
            return Promise.all([
                this.$http.post("master/areas"),
                this.$http.post("master/clienttypes"),
                this.$http.post("master/movementstrategy"),
                this.$http.post("master/clients"),
                this.$http.post("master/sections"),
                this.$http.post("master/warehouses"),
                this.$http.post("master/businesstypes"),
            ]).then(this.$http.spread((areas, clienttypes, movementstrategy, clients, sections, warehouses, businessTypes) => {
                areas.data.data.map(area => {
                    if (this.area.data.findIndex(a => a.id == area.id) === -1) {
                        this.area.data.push(area)
                    }
                })

                clienttypes.data.data.map(client_type => {
                    if (this.client_type.data.findIndex(a => a.id == client_type.id) === -1) {
                        this.client_type.data.push(client_type)
                    }
                })

                movementstrategy.data.data.map(inv_type => {
                    if (this.inv_type.data.findIndex(a => a.id == inv_type.id) === -1) {
                        this.inv_type.data.push(inv_type)
                    }
                })

                businessTypes.data.data.map(businessTypes => {
                    if (this.businessType.data.findIndex(a => a.id == businessTypes.id) === -1) {
                        this.businessType.data.push(businessTypes)
                    }
                })
            }))
        }
    },
    mounted() {
        this.fetchDropdown().then(() => this.fetchData())
        this.gridApi = this.gridOptions.api;
        // this.gridApi.sizeColumnsToFit();
    },
    beforeMount() {
        this.columnDefs = [
            // {
            //   headerName: "ID",
            //   field: "id",
            //   width: 50,
            //   filter: true,
            //   hide: true,
            //   checkboxSelection: true,
            //   headerCheckboxSelectionFilteredOnly: true,
            //   headerCheckboxSelection: true,
            // },
            {
                headerName: "Code",
                field: "client_code",
                width: 120,
                // checkboxSelection: true,
                // headerCheckboxSelectionFilteredOnly: true,
                // headerCheckboxSelection: true,
            },
            {
                headerName: "Name",
                field: "name",
                width: 120
            },
            {
                headerName: "Address 1",
                field: "address_1",
                width: 120
                // pinned: 'left'
            },
            {
                headerName: "Address 2",
                field: "address_2",
                width: 120
            },
            {
                headerName: "Type",
                field: "client_type",
                width: 120
            },
            {
                headerName: "Area",
                field: "village",
                width: 120
            },
            {
                headerName: "District",
                field: "district",
                width: 120
            },
            {
                headerName: "Post Code",
                field: "postcode",
                width: 120
            },
            {
                headerName: "Inventory Type",
                field: "inv_type",
                width: 120
            }
        ];
        this.gridOptions.getRowHeight = function (params) {
            return 35;
        }
    }
};
</script>
